import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Base} from '../../../common/model/base.model';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
    selector: 'app-list-item',
    template: `
     <div *ngIf="item">
         <div class="row pt-2 pb-2">
           <ng-content></ng-content>

           <div class="ddd">
             <div class="btn-group" [ngStyle]="buttonStyle()">

               <button class="btn btn-secondary btn-sm" [disabled]="!item.hasId()"
                      (click)="navigateShow()"><i class="fa fa-eye"></i></button>

               <button class="btn btn-primary btn-sm" [disabled]="!item.hasId() || noEdit" [routerLink]="[editRoute + item.getId()]">
                 <i class="fa fa-calendar"></i>
               </button>

               <button *ngIf="hasEditValidita"
                       class="btn btn-primary btn-sm"
                       [disabled]="!item.hasId() || noEdit"
                       [routerLink]="[editValiditaRoute + item.getId()]">
                 <i class="fa fa-calendar"></i>
               </button>

               <app-button-delete [disable]="!item.hasId() || noEdit"
                                  [entity]="item"
               [style]="{'border-top-left-radius': '0px', 'border-bottom-left-radius': '0px'}"
               (confirm)="onDelete.emit()"
               >
               </app-button-delete>

             </div>
           </div>
         </div>
    </div>
    `,
    styles: [
        'div.ddd { display: none; }',
        'div.row:hover div.ddd { display: block; }'
    ],
    standalone: false
})
export class ListItemComponent {

  constructor(private router: Router, private route: ActivatedRoute) {}

  @Input() item: Base = null;

  @Input() showRoute = 'show/';

  @Input() editRoute = 'edit/';

  @Input() deleteRoute = 'delete/';

  @Input() editValiditaRoute = 'editvalidita/';

  @Input() hasEditValidita = false;

  @Input() noEdit = false;

  @Output() onDelete = new EventEmitter();

  @Input() filterForm;

  @Input() page;

  public navigateShow() {
    this.router.navigate([this.showRoute + this.item.getId()],
      {
        relativeTo: this.route,
        queryParams: { page: 'prova'}
      });
  }

  buttonStyle() {
    return {
      'position': 'absolute',
      'top': '-2px',
      'left': '90%',
      'z-index': '100000'
      // 'position': 'absolute',
      // 'top': '0',
      // 'left': '0',
      // 'width': '100%',
      // 'height': '100%'
    };
  }
}

